import { Expandable } from '@dealstack/frontend/shared/components/Expandable/Expandable';
import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import { useTranslationMipCreate } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { memo } from 'react';
import styled from 'styled-components';

const InvestorsUploadInstructions = () => {
	const tMipCreate = useTranslationMipCreate();

	return (
		<Expandable title={tMipCreate('investors.expandable.title')}>
			<ExpandableBody>
				<Text variant="p-md" bold>
					{tMipCreate('investors.expandable.body.title')}
				</Text>
				<Text variant="p-md">{tMipCreate('investors.expandable.body.step1')}</Text>
				<Text variant="p-md">{tMipCreate('investors.expandable.body.step2')}</Text>
				<SubText variant="p-md">{tMipCreate('investors.expandable.body.step2a')}</SubText>
				<SubText variant="p-md">{tMipCreate('investors.expandable.body.step2b')}</SubText>
				<Text variant="p-md">{tMipCreate('investors.expandable.body.step3')}</Text>
				<Text variant="p-md">{tMipCreate('investors.expandable.body.step4')}</Text>
				<Text variant="p-md" bold>
					{tMipCreate('investors.expandable.body.warning')}
				</Text>
			</ExpandableBody>
		</Expandable>
	);
};

const SubText = styled(Text)`
	margin-left: 0.75em;
`;

const ExpandableBody = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1em;
	color: ${({ theme }) => theme.v2.color.neutral[1100]};
`;
const _InvestorsUploadInstructionsExport = memo(InvestorsUploadInstructions);

export { _InvestorsUploadInstructionsExport as InvestorsUploadInstructions };
